module.exports = __webpack_public_path__ + "img/img5.623eb9bb.png";